import { Label } from '@uds/label';
import { cx } from 'linaria';
import './datepicker.stylesheet_1rm535x.css';
import { Select } from '@uds/select';
import InclusivelyHidden from '@uds/inclusively-hidden';
import { jsx, jsxs } from 'react/jsx-runtime';

const root = "r19t78kl";
const content = {
  default: "d1em3jw3",
  stacked: "s186oxx6"
};
const picker = {
  default: "d1nn0cjc",
  stacked: "sxviys5"
};
const error = "e1rp3t3n";
const getClassNames = _ref => {
  let {
    stack
  } = _ref;
  return {
    root,
    content: cx(content.default, stack && content.stacked),
    picker: cx(picker.default, stack && picker.stacked),
    error
  };
};

const SelectDatepicker = _ref => {
  let {
    options,
    label,
    className,
    fn,
    ...props
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: className,
    children: /*#__PURE__*/jsx(Select, {
      ...props,
      label: /*#__PURE__*/jsx(InclusivelyHidden, {
        children: label
      }),
      children: options.length > 0 ? options.map(option => /*#__PURE__*/jsx("option", {
        value: option,
        children: fn ? fn(option) : option
      }, option)) : undefined
    })
  });
};
var SelectDatepicker$1 = SelectDatepicker;

const currentYear = new Date().getFullYear();
const getRange = function (to) {
  let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Array.from({
    length: to - from + 1
  }, (v, i) => from + i);
};
const Datepicker = _ref => {
  let {
    id,
    label,
    locale,
    days = getRange(31),
    months = getRange(12),
    years = getRange(currentYear, currentYear - 100).reverse(),
    selectedDay = '',
    selectedMonth = '',
    selectedYear = '',
    placeholderDay,
    placeholderMonth,
    placeholderYear,
    onDayChange,
    onMonthChange,
    onYearChange,
    stack = false,
    dayLabel,
    monthLabel,
    yearLabel,
    ...props
  } = _ref;
  const styles = getClassNames({
    stack
  });
  const hasLabel = label !== '' && label != null;
  const year = new Date().getFullYear();
  const lang = locale == null || locale === '' ? 'en-gb' : locale;
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/jsx("fieldset", {
      children: hasLabel && /*#__PURE__*/jsx(Label, {
        as: 'legend',
        id: `${id}-label`,
        htmlFor: id,
        children: label
      })
    }), /*#__PURE__*/jsxs("div", {
      id: id,
      className: styles.content,
      children: [/*#__PURE__*/jsx(SelectDatepicker$1, {
        ...props,
        id: `${id}-day`,
        label: dayLabel,
        placeholder: placeholderDay,
        className: styles.picker,
        options: days,
        value: selectedDay,
        onChange: onDayChange
      }), /*#__PURE__*/jsx(SelectDatepicker$1, {
        ...props,
        id: `${id}-month`,
        label: monthLabel,
        placeholder: placeholderMonth,
        className: styles.picker,
        options: months,
        value: selectedMonth,
        onChange: onMonthChange,
        fn: month => new Intl.DateTimeFormat(lang, {
          month: 'long'
        }).format(new Date(year, month - 1, 1))
      }), /*#__PURE__*/jsx(SelectDatepicker$1, {
        ...props,
        id: `${id}-year`,
        label: yearLabel,
        placeholder: placeholderYear,
        className: styles.picker,
        options: years,
        value: selectedYear,
        onChange: onYearChange
      })]
    }), props.error != null && /*#__PURE__*/jsx("div", {
      id: `${id}-error`,
      className: styles.error,
      children: props.error
    })]
  });
};
var Datepicker$1 = Datepicker;

export { Datepicker$1 as Datepicker };
